// Định nghĩa hàm để chặn sự kiện double click
export function stopDoubleClickPropagation(event: any) {
  event.preventDefault();
  event.stopPropagation();
}
